import { createSlice } from "@reduxjs/toolkit";

export const toastSlice = createSlice({
  name: "toasts",
  initialState: {
    toasts: [],
  },
  reducers: {
    add: (state, action) => {
      const tmpState = state;
      const { message, heading, options } = action.payload;
      const alreadyExist = options?.id
        ? tmpState.toasts.filter((f) => f.id === options.id)
        : [];
      if (alreadyExist.length === 0) {
        const id = options.id || new Date().getTime();
        tmpState.toasts = [
          ...tmpState.toasts,
          { id, message, heading, options },
        ];
      }
    },
    remove: (state, action) => {
      const tmpState = state;
      tmpState.toasts = tmpState.toasts.filter((f) => f.id !== action.payload);
    },
  },
});

export const { add, remove } = toastSlice.actions;

export default toastSlice.reducer;
